module.exports = __webpack_public_path__ + "static/media/slot-coins.b3acd1af.png";